import React, { useEffect, useRef } from "react";
import { useAuth } from "../context/AuthProvider";
import { useLanguage } from "../context/LanguageContext";
import { MainLayout } from "../global/Layout";
import { Button, CircularProgress, Box } from "@mui/material";

const centered = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
} as const;

const PrivateRoute = () => {
  const { t } = useLanguage();
  const { isAuthenticated, isLoading, login, keycloakInstance } = useAuth();
  const redirecting = useRef(false);

  // Pendant une déconnexion (drapeau posé par logout()), on laisse keycloak.logout() finir sa redirection :
  // relancer login() la ferait échouer, la session Keycloak étant encore active.
  const isLoggingOut = sessionStorage.getItem("just_logged_out") !== null;
  // Pas de session : on passe directement par l'écran de connexion Keycloak, sans page intermédiaire
  const shouldLogin = !isLoading && !isAuthenticated && keycloakInstance !== null && !isLoggingOut;

  useEffect(() => {
    if (!shouldLogin || redirecting.current) return;
    redirecting.current = true;
    login();
  }, [shouldLogin, login]);

  // Keycloak n'a pas pu s'initialiser (réseau, config) : bouton de repli plutôt qu'une boucle de redirections
  if (!isLoading && !isAuthenticated && keycloakInstance === null && !isLoggingOut) {
    return (
      <Box sx={centered}>
        <Button variant="contained" onClick={login}>{t("pages.login.loginButton")}</Button>
      </Box>
    );
  }

  if (isLoading || !isAuthenticated) {
    return (
      <Box sx={centered}>
        <CircularProgress />
      </Box>
    );
  }

  return <MainLayout />;
};

export default PrivateRoute;
